import { ApiService } from "../../../services/apiService";
import { routes } from "../../../services/paths";
import { appConstants } from "../../action-constants/inapp.constants";
import { Dispatch } from "redux";
import { handleRequestErrors } from "../../../shared/utils";

// Get Customer Details
export const GetCustomerDetails = (customerId: string) => {
    if (customerId !== "CLEAR") {
        return (dispatch: Dispatch) => {
            let apiConsume = ApiService.request({
                url: `${routes.GET_VENDOR_CONTACT_DETAILS}/${customerId}`,
                http_method: "GET",
            });
            dispatch(request(apiConsume));
            return apiConsume
                .then((response: any) => {
                    dispatch(success(response));
                })
                .catch((error: any) => {
                    dispatch(failure(handleRequestErrors(error)));
                });
        };
    }

    return (dispatch: Dispatch) => {
        dispatch(clear());
    };

    function request(params: any) {
        return { type: appConstants.GET_CUSTOMER_DETAILS_PENDING, params };
    }
    function success(response: any) {
        return { type: appConstants.GET_CUSTOMER_DETAILS_SUCCESS, response };
    }
    function failure(error: any) {
        return { type: appConstants.GET_CUSTOMER_DETAILS_FAILURE, error };
    }
    function clear() {
        return { type: appConstants.GET_CUSTOMER_DETAILS_RESET, clear_data: "" };
    }
};

// Update Customer
export const UpdateCustomer = (customerId: string, customerData: any) => {
    if (customerData !== "CLEAR") {
        return (dispatch: Dispatch) => {
            let apiConsume = ApiService.request({
                url: `${routes.UPDATE_CUSTOMER}/${customerId}`,
                http_method: "PUT",
                data: customerData,
            });
            dispatch(request(apiConsume));
            return apiConsume
                .then((response: any) => {
                    dispatch(success(response));
                })
                .catch((error: any) => {
                    dispatch(failure(handleRequestErrors(error)));
                });
        };
    }

    return (dispatch: Dispatch) => {
        dispatch(clear());
    };

    function request(params: any) {
        return { type: appConstants.UPDATE_CUSTOMER_PENDING, params };
    }
    function success(response: any) {
        return { type: appConstants.UPDATE_CUSTOMER_SUCCESS, response };
    }
    function failure(error: any) {
        return { type: appConstants.UPDATE_CUSTOMER_FAILURE, error };
    }
    function clear() {
        return { type: appConstants.UPDATE_CUSTOMER_RESET, clear_data: "" };
    }
};

// Get Customer Orders
export const GetCustomerOrders = (customerId: string, page: number = 1, size: number = 10) => {
    if (customerId !== "CLEAR") {
        return (dispatch: Dispatch) => {
            let apiConsume = ApiService.request({
                url: `${routes.GET_ORDERS}?UserId=${customerId}&Page=${page}&Size=${size}`,
                http_method: "GET",
            });
            dispatch(request(apiConsume));
            return apiConsume
                .then((response: any) => {
                    dispatch(success(response));
                })
                .catch((error: any) => {
                    dispatch(failure(handleRequestErrors(error)));
                });
        };
    }

    return (dispatch: Dispatch) => {
        dispatch(clear());
    };

    function request(params: any) {
        return { type: appConstants.GET_CUSTOMER_ORDERS_PENDING, params };
    }
    function success(response: any) {
        return { type: appConstants.GET_CUSTOMER_ORDERS_SUCCESS, response };
    }
    function failure(error: any) {
        return { type: appConstants.GET_CUSTOMER_ORDERS_FAILURE, error };
    }
    function clear() {
        return { type: appConstants.GET_CUSTOMER_ORDERS_RESET, clear_data: "" };
    }
};

// Get Customer Total Spent
export const GetCustomerTotalSpent = (customerId: string) => {
    if (customerId !== "CLEAR") {
        return (dispatch: Dispatch) => {
            let apiConsume = ApiService.request({
                url: `${routes.GET_CUSTOMER_TOTAL_SPENT}?UserId=${customerId}`,
                http_method: "GET",
            });
            dispatch(request(apiConsume));
            return apiConsume
                .then((response: any) => {
                    dispatch(success(response));
                })
                .catch((error: any) => {
                    dispatch(failure(handleRequestErrors(error)));
                });
        };
    }

    return (dispatch: Dispatch) => {
        dispatch(clear());
    };

    function request(params: any) {
        return { type: appConstants.GET_CUSTOMER_TOTAL_SPENT_PENDING, params };
    }
    function success(response: any) {
        return { type: appConstants.GET_CUSTOMER_TOTAL_SPENT_SUCCESS, response };
    }
    function failure(error: any) {
        return { type: appConstants.GET_CUSTOMER_TOTAL_SPENT_FAILURE, error };
    }
    function clear() {
        return { type: appConstants.GET_CUSTOMER_TOTAL_SPENT_RESET, clear_data: "" };
    }
};

// Get Customer Stores
export const GetCustomerStores = (customerId: string) => {
    if (customerId !== "CLEAR") {
        return (dispatch: Dispatch) => {
            let apiConsume = ApiService.request({
                url: `${routes.GET_STORES}?UserId=${customerId}`,
                http_method: "GET",
            });
            dispatch(request(apiConsume));
            return apiConsume
                .then((response: any) => {
                    dispatch(success(response));
                })
                .catch((error: any) => {
                    dispatch(failure(handleRequestErrors(error)));
                });
        };
    }

    return (dispatch: Dispatch) => {
        dispatch(clear());
    };

    function request(params: any) {
        return { type: appConstants.GET_CUSTOMER_STORES_PENDING, params };
    }
    function success(response: any) {
        return { type: appConstants.GET_CUSTOMER_STORES_SUCCESS, response };
    }
    function failure(error: any) {
        return { type: appConstants.GET_CUSTOMER_STORES_FAILURE, error };
    }
    function clear() {
        return { type: appConstants.GET_CUSTOMER_STORES_RESET, clear_data: "" };
    }
};
